import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Container, Box } from '@mui/material';
import Header from './components/Header';
import InstallAppPrompt from './components/InstallAppPrompt';
import ServiceWorkerRegistration from './components/ServiceWorkerRegistration';
import YandexMetrika from './components/YandexMetrika';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CategoryPage from './pages/CategoryPage';
import SearchResultsPage from './pages/SearchResultsPage';
import CartPage from './pages/CartPage';
import ViewedProductsPage from './pages/ViewedProductsPage';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#ffffff',
    },
    background: {
      default: '#fafafa',
    },
  },
  typography: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    h1: {
      fontWeight: 300,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 300,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 400,
      fontSize: '1.5rem',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
          {/* Компонент для отслеживания Яндекс.Метрики */}
          <YandexMetrika />
          <Header />
          <Container maxWidth="lg" sx={{ py: 4, pt: { xs: 12, md: 14 } }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/product" element={<ProductPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/category/:categoryId" element={<CategoryPage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/viewed" element={<ViewedProductsPage />} />
            </Routes>
          </Container>
          {/* Компонент для установки приложения */}
          <InstallAppPrompt />
          {/* Компонент для регистрации Service Worker и обновлений */}
          <ServiceWorkerRegistration />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
